import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/modules/session/services/authentication.service';

@Component({
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss']
})
export class AuthErrorComponent implements OnInit {

  constructor(private authService: AuthenticationService) { }

  ngOnInit(): void {
  }

  tryAgain() {
    this.authService.redirectToAuthenticate();
  }

  goToOkta() {
    window.location.href = 'https://lendio.okta.com/login/login.htm';
  }
}
